export default __webpack_public_path__ + "static/media/success.ec1a18cb.svg";